var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"role"},[_c('div',{staticClass:"open-wrap"},[_c('new-Insert',{attrs:{"type":"insert","clearData":_vm.clearData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }